import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
// import { isDevMode } from '@angular/core';

// if (isDevMode() && typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
//   navigator.serviceWorker.getRegistrations().then((registrations) => {
//     for (const registration of registrations) {
//       registration.unregister().then((success) => {
//         if (success) {
//           console.log('Unregistered stale service worker in development mode.');
//           window.location.reload();
//         }
//       });
//     }
//   });
// }

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
